import React, {Component} from 'react';
import {Button, Modal, Form} from 'semantic-ui-react';

import IngredientStockData from "../../data/IngredientStockData";
import {connect} from "react-redux";
import {openModalIngredientStockUpdate} from "../../actions/ModalIngredientStockUpdateActions";
import {updateIngredientStock} from "../../actions/IngredientStockActions";
import {showToast} from "../../actions/ToastAction";

class IngredientStockUpdate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            quantity: 0,
            quantity_error: false,
            sending: false,
            observations: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleClose = () => {
        this.props.openModalIngredientStockUpdate({
            is_open: false,
            is_add: true,
            ingredient: null,
            stock: null
        });
        this.setState({quantity:0, sending:false, quantity_error:false, observations:''});
    };


    handleSubmit(event) {
        event.preventDefault();
        if (this.state.quantity <= 0 || (this.state.quantity > this.props.modal.stock.total && !this.props.modal.is_add)) {
            this.setState({quantity_error: true})
        } else {
            this.setState({sending: true});
            let data = {
                ingredient: this.props.modal.ingredient.id,
                branch_office: this.props.modal.stock.id,
                quantity: this.props.modal.is_add ? this.state.quantity:(-1*this.state.quantity),
                track_type: this.props.modal.is_add ? 3:5,
                observations:  this.props.modal.is_add ? '':this.state.observations
            };
            IngredientStockData.update(data, (res) => {
                if (res.update) {
                    let stock = this.props.modal.stock;
                    stock.total += data.quantity;
                    this.props.updateIngredientStock(stock);
                    this.props.showToast({type:'success', message:res.message});
                    this.handleClose();
                } else {
                    this.props.showToast({type:'error', message:res.message});
                }
            }).catch(() =>{
                this.props.showToast({type:'error', message:'No hay conexión a internet!'});
            });
        }
    };

    handleTotalChange = (event) => {
        if (event.target.value.trim() !== '') {
            let quantity = parseFloat(event.target.value, 0);
            if (quantity >= 0) {
                this.setState({quantity})
                this.setState({quantity_error: false})
            } else {
                this.setState({quantity_error: true})
            }
        } else {
            this.setState({quantity_error: true, quantity: ''})
        }
    };

    handleObservationsChange = (event) => {
        this.setState({observations: event.target.value});
    };

    render() {
        return (
            <Modal size='tiny' dimmer='inverted' open={this.props.modal.is_open} onClose={this.handleClose}>
                <Modal.Header>{`${this.props.modal.ingredient ? this.props.modal.ingredient.name:''} (${this.props.modal.stock ? Math.round((this.props.modal.stock.total + Number.EPSILON) * 100) / 100:0} disponibles) - ${this.props.modal.is_add? 'Actualizar Inventario':'Dar de Baja'}`}</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Input label={`Unidades a ${this.props.modal.is_add ? 'Agregar':'Dar de Baja'}:`} min={0} step={'.01'} type='number' value={this.state.quantity}
                                        onChange={this.handleTotalChange} error={this.state.quantity_error}/>
                            {!this.props.modal.is_add ? <Form.TextArea label='Observaciones' placeholder='Observaciones'
                                                                       value={this.state.observations}
                                                                       onChange={this.handleObservationsChange}/>:null}
                        </Form>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.handleClose} icon='x' labelPosition='left' content="Cancelar"/>
                    <Button primary loading={this.state.sending} disabled={this.state.sending} icon='check'
                            labelPosition='left' content={`${this.props.modal.is_add ? 'Actualizar':'Dar de Baja'}`} onClick={this.handleSubmit}/>
                </Modal.Actions>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('ingredient_stock_update_modal'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalIngredientStockUpdate(modal){
            dispatch(openModalIngredientStockUpdate(modal))
        },
        showToast(toast){
            dispatch(showToast(toast))
        },
        updateIngredientStock(ingredient_stock){
            dispatch(updateIngredientStock(ingredient_stock))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IngredientStockUpdate);



// WEBPACK FOOTER //
// ./src/components/inventories/IngredientStockUpdate.js